import PropTypes from 'prop-types'
import { Button, Popconfirm } from 'antd'
import { DeleteOutlined, EditOutlined } from '@ant-design/icons'
import { createUseStyles } from 'react-jss'

const useStyles = createUseStyles({
  card: {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
  name: {
    fontWeight: 600,
    fontSize: 15,
    minWidth: 0,
    overflowWrap: 'anywhere',
  },
  line: {
    fontSize: 13,
    color: '#595959',
    overflowWrap: 'anywhere',
  },
  // Edit and delete share the last line, left-aligned so their labels sit flush
  // with the text above them.
  actionsLine: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    gap: 14,
    marginTop: 4,
  },
})

const ACTION_BUTTON_STYLE = { paddingLeft: 0 }

// Every desktop column fits on the card, so these rows need no expand toggle.
// The area code keeps its own line instead of being merged into the number:
// both are free-form fields and the stored number may already include it.
export default function PhoneNumberMobileCard({
  letterPhoneNumber,
  onEdit,
  onDelete,
}) {
  const classes = useStyles()
  const { areaCode, id, phoneNumber } = letterPhoneNumber

  return (
    <div className={classes.card}>
      <div className={classes.name}>{phoneNumber || '—'}</div>
      <div className={classes.line}>Area code: {areaCode || '—'}</div>
      <div className={classes.actionsLine}>
        <Button
          type="link"
          size="small"
          icon={<EditOutlined />}
          style={ACTION_BUTTON_STYLE}
          onClick={() => onEdit(id)}
        >
          Edit
        </Button>
        <Popconfirm
          title="Are you sure you want to delete this phone number?"
          onConfirm={() => onDelete(id)}
          okText="Yes"
          cancelText="No"
          placement="topRight"
        >
          <Button
            type="link"
            size="small"
            icon={<DeleteOutlined />}
            style={ACTION_BUTTON_STYLE}
            className="delete-button"
          >
            Delete
          </Button>
        </Popconfirm>
      </div>
    </div>
  )
}

PhoneNumberMobileCard.propTypes = {
  letterPhoneNumber: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
    areaCode: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    phoneNumber: PropTypes.string,
  }).isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
}
